import { MeterStatus, type IFuelTypes } from "@origin-digital/sales-common";
import { isErgonSolar } from "@origin-digital/sales-common-types-fns";
import type { ConnectionAddressObject } from "@origin-digital/sales-energy-address-lookup";

// Use after address resolution/confirmation has completed.
export const getAddressFuel = (
  address: ConnectionAddressObject
): IFuelTypes | undefined => {
  const electricity =
    (address.nmiStatus === MeterStatus.FOUND ||
      address.nmiStatus === MeterStatus.BELOW_THRESHOLD) &&
    !isErgonSolar(address);
  const gas = address.mirnStatus !== MeterStatus.NOT_SERVICEABLE;

  if (electricity && gas) return "dual";
  if (electricity) return "electricity";
  return gas ? "gas" : undefined;
};
